var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAccessMonitoring({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1 10.28C12.6633 10.28 13.12 9.82333 13.12 9.26C13.12 8.69667 12.6633 8.24 12.1 8.24C11.5367 8.24 11.08 8.69667 11.08 9.26C11.08 9.82333 11.5367 10.28 12.1 10.28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H15V12.05H16.5V3C16.5 2.17 15.83 1.5 15 1.5H3C2.17 1.5 1.5 2.17 1.5 3V21C1.5 21.83 2.17 22.5 3 22.5H9V21H3V3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.18 13.29H21.68V4.5C21.68 3.67 21.01 3 20.18 3H17.93V4.5H20.18V13.29Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19.42C17.3284 19.42 18 18.7484 18 17.92C18 17.0916 17.3284 16.42 16.5 16.42C15.6716 16.42 15 17.0916 15 17.92C15 18.7484 15.6716 19.42 16.5 19.42Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.33 17.61C21.38 15.2 19.09 13.58 16.5 13.5C13.91 13.58 11.61 15.2 10.67 17.61L10.5 18L10.67 18.39C11.62 20.8 13.91 22.42 16.5 22.5C19.09 22.42 21.39 20.8 22.33 18.39L22.5 18L22.33 17.61ZM16.5 21C14.84 21 13.5 19.66 13.5 18C13.5 16.34 14.84 15 16.5 15C18.16 15 19.5 16.34 19.5 18C19.5 19.66 18.16 21 16.5 21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccessMonitoring);
export default __webpack_public_path__ + "static/media/ic-access-monitoring.4b0d5f487278bb105652513bcedd141a.svg";
export { ForwardRef as ReactComponent };